import axios from 'axios';

export default {
    updateProperty(orderId, propertyName, value) {
        return axios.post('/order/updateProperty/', {
            orderId,
            propertyName,
            value,
        });
    },
    productTypesForOrder(orderId) {
        return axios.post('/order/producttypesForOrder/', {
            orderId: orderId || undefined,
        });
    },
    fetchAllOrderTypes() {
        return axios.post('/order/fetchAllOrderTypes/');
    },
    clearAutoProcessedOrders() {
        return axios.post('/order/clearAutoProcessedOrders');
    },
    manualOrdersForWinfakt() {
        return axios.post('/order/manualOrdersForWinfakt');
    },
    quotations() {
        return axios.post('/order/quotations');
    },
    autoProcessedOrders() {
        return axios.post('/order/autoProcessedOrders');
    },
    fetchAndProcessOrders() {
        return axios.post('/order/fetchAndProcessOrders/');
    },
    fetchServicesForWinfakt() {
        return axios.post('/order/fetchServicesForWinfakt');
    },
    createOrder(customerId) {
        return axios.post('/order/createOrder/', { customerId });
    },
    createServiceOrder(customerId) {
        return axios.post('/order/createServiceOrder/', { customerId });
    },
    saveQuotationRemarks(orderId, quotationRemarks) {
        return axios.post('/order/saveQuotationRemarks', {
            orderId,
            quotationRemarks,
        });
    },
    setOrderState(orderId, state) {
        return axios.post('/order/setOrderState', { orderId, state });
    },
    setPickupDate(orderId, deliveryDateId) {
        return axios.post('/order/setPickupDate/', { orderId, deliveryDateId });
    },
    setDeliveryDate(orderId, deliveryDateId) {
        return axios.post('/order/setDeliveryDate/', {
            orderId,
            deliveryDateId,
        });
    },
    setProductionDate(orderId, productionDate) {
        return axios.post('/order/setProductionDate/', {
            orderId,
            productionDate,
        });
    },
    isWorkingDay(date) {
        return axios.post('/order/isWorkingDay/', { date });
    },
    fetchClosestWorkingDay(date, allowBefore = true, allowAfter = true) {
        return axios.post('/order/fetchClosestWorkingDay/', {
            date: date.format('YYYY-MM-DD'),
            allowBefore,
            allowAfter,
        });
    },
    createCrmOrderConfirmation(orderId) {
        return axios.post('/order/createCrmOrderConfirmation/', { orderId });
    },
    updateCrmOrderConfirmation(orderId) {
        return axios.post('/order/updateCrmOrderConfirmation/', { orderId });
    },
    setVAT(orderId, vat) {
        return axios.post('/order/setBtw/', { orderId, btw: vat });
    },
    setPaintshop(orderId, paintshop) {
        return axios.post('/order/setPaintshop/', { orderId, paintshop });
    },
    updateWaitForOrderConfirmation(orderId, waiting) {
        return axios.post('/order/updateWaitForOrderConfirmation/', {
            id: orderId,
            waiting,
        });
    },
    moveProductsToNewOrder(orderId, products) {
        return axios.post('/order/moveProductsToNewOrder', {
            orderId,
            products,
        });
    },
    createServiceOrderFromProduct(productId) {
        return axios.post('/order/createServiceOrderFromProduct/', {
            productId,
        });
    },
    validateOrderExistance(orderId) {
        return axios.post('/order/validateOrderExistance/', { orderId });
    },
    validateServiceOrderExistance(orderId) {
        return axios.post('/order/validateServiceOrderExistance/', { orderId });
    },
    productsForServiceOrder(orderId) {
        return axios.post('/product/productsForServiceOrder/', { orderId });
    },
    earliestPossibleDeliveryDateForOrder(orderId) {
        return axios.post('/order/earliestPossibleDeliveryDateForOrder/', {
            orderId,
        });
    },
    rejectOrder(orderId, employeeId) {
        return axios.post(`[API]/orders/${orderId}/reject`, {
            employeeId,
        });
    },
};
